const errorMessages = {
  wrongPassword: "The email and password you entered don't match",
  weakPassword: 'Strong passwords have at least 6 characters and a mix of letters and numbers',
  emailAlreadyInUse: 'The email address is already used by another account',
  invalidEmail: "That email address isn't correct",
  userNotFound: "That email address doesn't match an existing account"
}

export default errorMessages
